import fr from "./fr.json";
import en from "./en.json";

const translations = { fr, en };

export default translations;
